import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from '../Layout/Layout';
import style from './App.module.css';
import { useState } from 'react';
import HomePage from '../../pages/HomePage/HomePage';
import BlogPageEn from '../../pages/BlogPageEn/BlogPageEn';
import BlogArticlePageEn from '../../pages/BlogPageEn/BlogArticlePageEn/BlogArticlePageEn';
import BlogPageDe from '../../pages/BlogPageDe/BlogPageDe';
import BlogArticlePageDe from '../../pages/BlogPageDe/BlogArticlePageDe/BlogArticlePageDe';
import BlogPageIt from '../../pages/BlogPageIt/BlogPageIt';
import BlogArticlePageIt from '../../pages/BlogPageIt/BlogArticlePageIt.jsx/BlogArticlePageIt';

const App = ({}) => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate replace to="/en/" />} />

        <Route path="/en/blog" element={<BlogPageEn />} />
        <Route
          path="/en/blog/article/:title/:id"
          element={<BlogArticlePageEn />}
        />
        {/* Blog DE */}
        <Route path="/de/blog" element={<BlogPageDe />} />
        <Route
          path="/de/blog/article/:title/:id"
          element={<BlogArticlePageDe />}
        />

        {/* Blog IT */}
        <Route path="/it/blog" element={<BlogPageIt />} />
        <Route
          path="/it/blog/article/:title/:id"
          element={<BlogArticlePageIt />}
        />

        {/* Main Layout */}
        <Route path="/:lang/*" element={<HomePage />}></Route>
      </Routes>
    </Layout>
  );
};

export default App;
